/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-closing-tag-location */
/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-warning-comments */
/* eslint-disable react/jsx-no-target-blank */
import React, { useContext } from 'react';
import footerLogo from 'wmic-qb-digital-theme-styles/images/W-TM_Horizontal_White.png';
import bestLogo from 'wmic-qb-digital-theme-styles/sass/qbpv4ootb/images/demo/AMBest-Ap-Rating.png';
import { CONSTANTS } from 'wmic-portals-utils-js';
import { TranslatorContext } from '@jutro/locale';
import messages from './WMICCustomFooter.messages';

function WMICCustomFooter(props) {
    const translator = useContext(TranslatorContext);
    const currentYear = new Date().getFullYear();
    const WINSURANCE_DOMAIN = CONSTANTS.WINSURANCE_URL;
    
    const { regionLongName } = props;

    return (
        <footer className="wawanesa-web noprint footer ww-footer">
            <div className="footer-one-container">
                <div className=" ww-footer-one">
                    <div className="column1">
                        <h4>About Us</h4>
                        <ul className="wmicFooterNoMargin">
                            <li>
                                <a
                                    href={`${WINSURANCE_DOMAIN}/support/contact-us`}
                                    target="_blank"
                                >
                                    Contact Us
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`${WINSURANCE_DOMAIN}/legal/privacy-policy`}
                                    target="_blank"
                                >
                                    Privacy Policy
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`${WINSURANCE_DOMAIN}/legal/privacy-notice`}
                                    target="_blank"
                                >
                                    Insurance Privacy Notice
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`${WINSURANCE_DOMAIN}/legal/terms-and-conditions`}
                                    target="_blank"
                                >
                                    Terms of Use
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`${WINSURANCE_DOMAIN}/about-us/company-information`}
                                    target="_blank"
                                >
                                    Company Information
                                </a>
                            </li>
                            <li>
                                <a
                                    href={`${WINSURANCE_DOMAIN}/about-us/accessibility`}
                                    target="_blank"
                                >
                                    Accessibility
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div className="column2">
                        For information about the categories of personal information collected, the purposes for which it is collected 
                        or used and whether that information is sold or shared, visit our <a
                            className="ww-footer-privacy"
                            href={`${WINSURANCE_DOMAIN}/legal/privacy-policy`}
                            target="_blank"
                        >
                                Privacy Policy.
                        </a>
                    </div>

                    <div className="column3 ww-footer-logo is-half">
                        <img alt="W Insurance" src={footerLogo} />
                    </div>
                </div>
            </div>

            <div className="ww-footer-two">
                <div className="column copy">
                    <p>
                        Copyright &copy; 1996-
                        {currentYear} W Insurance
                    </p>
                    <p>
                        &quot;W Insurance&quot; is a trademark
                        <br />
                        of W Insurance Company
                    </p>
                </div>
                <div className="column is-half ww-footer-links col-right-wrapper">
                    {/* <div className="ww-social-icons">
                        <div className="facebook">
                            <a href="https://www.facebook.com/wawanesaus" title="Wawanesa on Facebook">
                                <i className="fab fa-facebook-square" />
                            </a>
                        </div>
                        <div className="instagram">
                            <a href="https://www.instagram.com/wawanesaus/" title="Wawanesa on Instagram">
                                <i className="fab fa-instagram-square" />
                            </a>
                        </div>
                        <div className="twitter">
                            <a href="https://twitter.com/WawanesaUS" title="Wawanesa on Twitter">
                                <i className="fab fa-twitter-square" />
                            </a>
                        </div>
                    </div> */}
                    <div className="ww-ambest-wrapper">
                        <a
                            className="ww-ambest"
                            target="_blank"
                            href={`${WINSURANCE_DOMAIN}/about-us/company-information#financialRatings`}
                        >
                            <img id="logoAMBest" alt={translator(messages.amBestImgAltText)} src={bestLogo} />
                        </a>
                    </div>
                    {/* <div>
                        <p>This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy">Privacy Policy</a> and <a href="https://policies.google.com/terms">Terms of Service</a> apply.</p>
                    </div> */}
                </div>
            </div>
        </footer>
    )
}

export default WMICCustomFooter;
